module.exports = __webpack_public_path__ + "img/play.dd8460ce.png";